import { gql } from '@apollo/client';

export const DAILY_AVG_FIELDS = gql`
    fragment DailyAverageFields on DailyAverage {
        isDefaultValue
        key
        value
        valueType
    }
`;

export const WEEKLY_AVG_FIELDS = gql`
    fragment WeeklyAverageFields on WeeklyAverageResult {
        key
        value
        valueType
    }
`;

export const MONTHLY_AVG_FIELDS = gql`
    fragment MonthlyAverageFields on MonthlyAverageResult {
        key
        value
        valueType
    }
`;

export const DEVICE_FIELDS = gql`
    fragment DeviceFields on Device {
        activated
        activatedDate
        deviceId
        deviceType
        lastRefreshDate
    }
`;

export const USER_FIELDS = gql`
    ${DEVICE_FIELDS}
    fragment UserFields on User {
        authId
        age
        firstName
        gender
        birthday
        bookings {
            bookingPartyId
            from
            guests {
                firstName
                lastName
                memberId
            }
            to
            id
            bookingType
            reports {
                link
                reportType
                userReportDate
            }
            property {
                description
                ianaCode
                id
                name
            }
        }
        preferredName
        gmsEmailAddress
        lastName
        memberId
        membersPortalEmailAddress
        whoopAccessToken
        whoopDeviceId
        whoopRefreshToken
        termsAndConditions {
            accepted
            text
        }
        devices {
            ...DeviceFields
        }
    }
`;
